<template>
  <div class="exchange-project">
    <TradingCenterQueryControl v-model.sync="ListFilter" :total="paginationParam.total" :isOffline="isOffline" />
    <div class="projectItem-container" v-loading="loading">
      <ProjectItem v-for="item in ListData" :index.sync="$route.query.index" :data="item" :key="item.offlineProjectId" />
      <div v-if="ListData.length === 0" class="No-data">暂无数据</div>
    </div>
    <Pagination :total="paginationParam.total" :page.sync="paginationParam.pageNumber" :limit.sync="paginationParam.pageSize" @pagination="getListData" />
  </div>
</template>
<script>
import TradingCenterQueryControl from '@/views/home/components/TradingCenterQueryControl'
import ProjectItem from '@/views/home/components/ProjectItemOffline'
import Pagination from '@/components/Pagination'
import { sessionStore } from "@/utils/data-management";
export default {
  components: {
    TradingCenterQueryControl,
    ProjectItem,
    Pagination,
  },
  data() {
    return {
      paginationParam: {
        pageNumber: 1,
        pageSize: 12,
        total: 0,
      },
      ListFilter: {
        businessType: '',
        location: '',
        transferType: '',
        start: '',
        end: '',
        areaConfigId: '',
        name: '', // 导航搜索
      },
      ListData: [],
      loading: false,
    }
  },
  computed: {
    isOffline() {
      window.scrollTo(0, 0)
      let index = this.$route.query.index
      if (index == 3) {
        this.getListData()
        return 1
      } else {
        this.ListFilter.name = this.$route.query.search
        this.getListData()
        return 0
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == 'OfflineProjectDetails') {
      let pageParams = {
        formInfo: this.ListFilter,
        paginationParam: this.paginationParam,
      }
      sessionStore.set('pageParamsOffline', JSON.stringify(pageParams))
    } else if (sessionStore.get('pageParamsOffline')) {
      sessionStore.remove('pageParamsOffline')
    }
    next()
  },
  beforeRouteEnter(to, from, next) {
    next((vim) => {
      let pageParams = sessionStore.get('pageParamsOffline')
      if ((from.name == 'OfflineProjectDetails') && pageParams) {
        pageParams = JSON.parse(pageParams)
        vim.ListFilter = pageParams.formInfo
        vim.paginationParam = pageParams.paginationParam
        vim.getListData()
      }
    })
  },
  methods: {
    searchData(){
      this.paginationParam.pageNumber = 1
      this.getListData()
    },
    getListData() {
      this.Loading = true
      let data = JSON.parse(JSON.stringify(this.ListFilter))
      Object.keys(data).forEach((key) => {
        if (data[key] == '') {
          delete data[key]
        }
      })
      this.Loading = false
      let params = {
        ...data,
        ...this.paginationParam,
      }
      this.$api.trade
        .getOfflineTradeList(params)
        .then((res) => {
          if (res.code == 1000) {
            this.ListData = res.data
            this.paginationParam.total = res.total
          }
        })
        .finally(() => {
          this.Loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.exchange-project {
  max-width: 1200px;
  margin: 0 auto 0;
  .projectItem-container {
    padding: 0 0 10px;
    display: flex;
    flex-wrap: wrap;
  }
  .No-data {
    width: 100%;
    text-align: center;
    line-height: 330px;
  }
}
</style>
